function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { inputRules, textblockTypeInputRule, wrappingInputRule, InputRule } from 'prosemirror-inputrules';
export default class InputRules {
  constructor(config, schema) {
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "rules", void 0);
    this.config = config;
    this.schema = schema;
    this.rules = [];
    if (this.config.inputRules) {
      this.config.inputRules.forEach(r => {
        this.addRule(r);
      });
    }
  }
  get plugin() {
    return inputRules({
      rules: this.rules
    });
  }
  addRule(config) {
    switch (config.type) {
      case 'wrapping':
        this.addWrappingRule(config);
        break;
      case 'textblock':
        this.addTextblockRule(config);
        break;
      case 'custom':
        this.addCustomRule(config);
        break;
    }
  }
  addWrappingRule(config) {
    let nodeType = this.schema.nodes[config.replaceWith];
    if (nodeType) {
      this.rules.push(wrappingInputRule(config.matcher, nodeType));
    }
  }
  addTextblockRule(config) {
    let nodeType = this.schema.nodes[config.replaceWith];
    if (nodeType) {
      this.rules.push(textblockTypeInputRule(config.matcher, nodeType));
    }
  }
  addCustomRule(config) {
    this.rules.push(new InputRule(config.matcher, config.handler));
  }
}